import React from 'react';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import { useRouter } from 'next/router';
import ServerPath from '../../configs/serverPath';
import getImgLocale from '../../utils/getImgLocale';
import FootText from '../Footer/FooterText';

const AccessDeniedPage = () => {
    const { siteName, composePath, preferredSiteName } = useSiteInfo();
    const { locale } = useRouter();

    return (
        <div className="c-access-denied">
            <div className="c-access-denied-header">
                <div className="c-logo">
                    <img
                        src={composePath({
                            pathType: ServerPath.siteImage,
                            pathName: `logo_slogan/logo_${getImgLocale(siteName, locale)}.svg`,
                        })}
                        alt=""
                    />
                </div>
            </div>
            <div className="c-access-denied-main">
                <div className="c-access-denied-main__img">
                    <img
                        src={composePath({ pathType: ServerPath.globalImage, pathName: 'access_denied/Visual.png' })}
                        alt=""
                    />
                </div>
                <div className="c-access-denied-main__title">
                    <i className="c-icon c-icon--ban" />
                    <span className="c-text-group">
                        <span className="c-text c-text--highlight">Access Denied</span>
                        <span className="c-text">禁止访问 / Truy cập bị từ chối</span>
                    </span>
                </div>
                <div className="c-access-denied-main__list">
                    <span className="c-text-group">
                        <span className="c-text c-text--title">Dear Valued Customers：</span>
                        <span className="c-text">
                            Viewing and using this website at your current location is prohibited due to its regulatory rules.
                            <br />
                            We regret any inconvenience.
                        </span>
                    </span>
                    <span className="c-text-group">
                        <span className="c-text c-text--title">敬愛的客户:</span>
                        <span className="c-text">
                            您所在的地区法规条例是禁止访问及使用本站。
                            <br />
                            不便之处，敬请见谅！
                        </span>
                    </span>
                    <span className="c-text-group">
                        <span className="c-text c-text--title">Kính gửi Quý khách hàng,</span>
                        <span className="c-text">
                            Việc truy cập và sử dụng trang Web này đã bị cấm theo quy định pháp luật ở địa điểm hiện tại của bạn.
                            <br />
                            Chúng tôi rất tiếc vì sự bất tiện này.
                        </span>
                    </span>
                </div>
            </div>
            <div className="c-access-denied-footer">
                <span className="c-text"><FootText siteName={preferredSiteName || siteName} /></span>
            </div>
        </div>
    );
};

export default AccessDeniedPage;
